import React from 'react';
import * as XLSX from 'xlsx';

const JsonToExcelDownloader = ({ dataArray, fileName }) => {
  const convertJsonToExcel = () => {
    const jsonSheet = XLSX.utils.json_to_sheet(dataArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, jsonSheet, 'Data');

    // Calculate column widths based on content
    const columnWidths = calculateColumnWidths(jsonSheet);

    // Set column widths
    jsonSheet['!cols'] = columnWidths;

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(excelBlob);
    downloadLink.setAttribute('download', fileName || 'data.xlsx');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const calculateColumnWidths = (sheet) => {
    const columnWidths = [];
    const range = XLSX.utils.decode_range(sheet['!ref']);

    for (let i = range.s.c; i <= range.e.c; i++) {
      let maxLength = 0;
      for (let j = range.s.r + 1; j <= range.e.r; j++) {
        const cell = sheet[XLSX.utils.encode_cell({ r: j, c: i })];
        if (cell && cell.v) {
          const cellLength = String(cell.v).length;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        }
      }
      columnWidths.push({ wch: maxLength + 2 }); // Add some padding
    }

    return columnWidths;
  };

  return (
    <span className="text-blue">
      <b>
        <span className="fa fa-file-o"></span>
        <button className='print-btn btn btn-info' onClick={convertJsonToExcel}>
          Export <i className="fa-solid fa-file-excel"></i>
        </button>
      </b>
    </span>
  );
};

export default JsonToExcelDownloader;
